import React from 'react';

// styling
import styled from 'styled-components';

// constants
import { TimelineColumnWidth, Timeline30MinLayoutColumnWidth } from '../../../../utils/timeline-constants'

const TimelineColumnDiv = styled.div`
  border: 1px solid lightgrey;
  min-width: ${Timeline30MinLayoutColumnWidth}; 
  min-height: 75px;
  text-align:'center';
`;
const TimelineColumnContainer = (props) => {

    return (
        <TimelineColumnDiv
            style={{
                display: 'flex',
                borderStyle: 'solid', borderWidth: 1,
                width: props?.is30MinLayout ? Timeline30MinLayoutColumnWidth : TimelineColumnWidth,
                textAlign: 'center',
                position: "relative",
                border: '1px solid lightgrey',
                backgroundColor: props.backgroundColor,
                borderColor: props.borderColor,
                minWidth: props?.is30MinLayout ? Timeline30MinLayoutColumnWidth : TimelineColumnWidth,
            }}
            onClick={props.onClick}
        >
            {props.children}
        </TimelineColumnDiv>
    );
};

export default TimelineColumnContainer;
